import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import SelfManagement from './competency-images/self-management.svg';
import SelfAwareness from './competency-images/self-awareness.svg';
import SocialAwareness from './competency-images/social-awareness.svg';
import RelationshipSkills from './competency-images/relationship-skills.svg';
import ResponsibleDecisionMaking from './competency-images/responsible-decision-making.svg';
import ImpulseControl from './competency-images/impulse-control.svg';
import StressManagement from './competency-images/stress-management.svg';
import GoalSetting from './competency-images/goal-setting.svg';
import IdentifyingEmotions from './competency-images/identifying-emotions.svg';
import RecognizingStrengths from './competency-images/recognizing-strengths.svg';
import SelfConfidence from './competency-images/self-confidence.svg';
import Empathy from './competency-images/empathy.svg';
import AppreciatingDiversity from './competency-images/appreciating-diversity.svg';
import RespectForOthers from './competency-images/respect-for-others.svg';
import Communication from './competency-images/communication.svg';
import SocialEngagement from './competency-images/social-engagement.svg';
import Teamwork from './competency-images/teamwork.svg';
import AnalyzingSituations from './competency-images/analyzing-situations.svg';
import SystemOfProblemSolving from './competency-images/system-of-problem-solving.svg';
import ReflectingOnActions from './competency-images/reflecting-on-actions.svg';

// Relationship Skills
import ConflictResolution1 from 'assets/img/badges/Relationship-Skills/Badge-Conflict-Resolution-Level-1.svg';
import ConflictResolution2 from 'assets/img/badges/Relationship-Skills/Badge-Conflict-Resolution-Level-2.svg';
import ConflictResolution3 from 'assets/img/badges/Relationship-Skills/Badge-Conflict-Resolution-Level-3.svg';
import ConflictResolution4 from 'assets/img/badges/Relationship-Skills/Badge-Conflict-Resolution-Level-4.svg';
import ConflictResolution5 from 'assets/img/badges/Relationship-Skills/Badge-Conflict-Resolution-Level-5.svg';
import ConflictResolutionMaster from 'assets/img/badges/Relationship-Skills/Badge-Conflict-Resolution-Master.svg';
import PositiveCommunication1 from 'assets/img/badges/Relationship-Skills/Badge-Positive-Communication-Level-1.svg';
import PositiveCommunication2 from 'assets/img/badges/Relationship-Skills/Badge-Positive-Communication-Level-2.svg';
import PositiveCommunication3 from 'assets/img/badges/Relationship-Skills/Badge-Positive-Communication-Level-3.svg';
import PositiveCommunication4 from 'assets/img/badges/Relationship-Skills/Badge-Positive-Communication-Level-4.svg';
import PositiveCommunication5 from 'assets/img/badges/Relationship-Skills/Badge-Positive-Communication-Level-5.svg';
import PositiveCommunicationMaster from 'assets/img/badges/Relationship-Skills/Badge-Positive-Communication-Master.svg';
import SocialEngagement1 from 'assets/img/badges/Relationship-Skills/Badge-Social-Engagement-Level-1.svg';
import SocialEngagement2 from 'assets/img/badges/Relationship-Skills/Badge-Social-Engagement-Level-2.svg';
import SocialEngagement3 from 'assets/img/badges/Relationship-Skills/Badge-Social-Engagement-Level-3.svg';
import SocialEngagement4 from 'assets/img/badges/Relationship-Skills/Badge-Social-Engagement-Level-4.svg';
import SocialEngagement5 from 'assets/img/badges/Relationship-Skills/Badge-Social-Engagement-Level-5.svg';
import SocialEngagementMaster from 'assets/img/badges/Relationship-Skills/Badge-Social-Engagement-Master.svg';
// Self Awareness
import Strengthsandlimitations1 from 'assets/img/badges/Self-Awareness/Badge-Identifies-Strengths-and-Limitations-Level-1.svg';
import Strengthsandlimitations2 from 'assets/img/badges/Self-Awareness/Badge-Identifies-Strengths-and-Limitations-Level-2.svg';
import Strengthsandlimitations3 from 'assets/img/badges/Self-Awareness/Badge-Identifies-Strengths-and-Limitations-Level-3.svg';
import Strengthsandlimitations4 from 'assets/img/badges/Self-Awareness/Badge-Identifies-Strengths-and-Limitations-Level-4.svg';
import Strengthsandlimitations5 from 'assets/img/badges/Self-Awareness/Badge-Identifies-Strengths-and-Limitations-Level-5.svg';
import StrengthsandlimitationsMaster from 'assets/img/badges/Self-Awareness/Badge-Identifies-Strengths-and-Limitations-Master.svg';
import CommunicatesFeelings1 from 'assets/img/badges/Self-Awareness/Badge-Identifies-and-Communicates-Feelings-Level-1.svg';
import CommunicatesFeelings2 from 'assets/img/badges/Self-Awareness/Badge-Identifies-and-Communicates-Feelings-Level-2.svg';
import CommunicatesFeelings3 from 'assets/img/badges/Self-Awareness/Badge-Identifies-and-Communicates-Feelings-Level-3.svg';
import CommunicatesFeelings4 from 'assets/img/badges/Self-Awareness/Badge-Identifies-and-Communicates-Feelings-Level-4.svg';
import CommunicatesFeelings5 from 'assets/img/badges/Self-Awareness/Badge-Identifies-and-Communicates-Feelings-Level-5.svg';
import CommunicatesFeelingsMaster from 'assets/img/badges/Self-Awareness/Badge-Identifies-and-Communicates-Feelings-Master.svg';
import PersonalQualities1 from 'assets/img/badges/Self-Awareness/Badge-Recognizes-Personal-Qualities-and-Interests-Level-1.svg';
import PersonalQualities2 from 'assets/img/badges/Self-Awareness/Badge-Recognizes-Personal-Qualities-and-Interests-Level-2.svg';
import PersonalQualities3 from 'assets/img/badges/Self-Awareness/Badge-Recognizes-Personal-Qualities-and-Interests-Level-3.svg';
import PersonalQualities4 from 'assets/img/badges/Self-Awareness/Badge-Recognizes-Personal-Qualities-and-Interests-Level-4.svg';
import PersonalQualities5 from 'assets/img/badges/Self-Awareness/Badge-Recognizes-Personal-Qualities-and-Interests-Level-5.svg';
import PersonalQualitiesMaster from 'assets/img/badges/Self-Awareness/Badge-Recognizes-Personal-Qualities-and-Interests-Master.svg';
// Social Awareness
import AppreciatingDiversity1 from 'assets/img/badges/Social-Awareness/Badge-Appreciating-Diversity-Level-1.svg';
import AppreciatingDiversity2 from 'assets/img/badges/Social-Awareness/Badge-Appreciating-Diversity-Level-2.svg';
import AppreciatingDiversity3 from 'assets/img/badges/Social-Awareness/Badge-Appreciating-Diversity-Level-3.svg';
import AppreciatingDiversity4 from 'assets/img/badges/Social-Awareness/Badge-Appreciating-Diversity-Level-4.svg';
import AppreciatingDiversity5 from 'assets/img/badges/Social-Awareness/Badge-Appreciating-Diversity-Level-5.svg';
import AppreciatingDiversityMaster from 'assets/img/badges/Social-Awareness/Badge-Appreciating-Diversity-Master.svg';
import Empathy1 from 'assets/img/badges/Social-Awareness/Badge-Empathy-Level-1.svg';
import Empathy2 from 'assets/img/badges/Social-Awareness/Badge-Empathy-Level-2.svg';
import Empathy3 from 'assets/img/badges/Social-Awareness/Badge-Empathy-Level-3.svg';
import Empathy4 from 'assets/img/badges/Social-Awareness/Badge-Empathy-Level-4.svg';
import Empathy5 from 'assets/img/badges/Social-Awareness/Badge-Empathy-Level-5.svg';
import EmpathyMaster from 'assets/img/badges/Social-Awareness/Badge-Empathy-Master.svg';
import ActionsAffect1 from 'assets/img/badges/Social-Awareness/Badge-How-Actions-Affect-Others-Level-1.svg';
import ActionsAffect2 from 'assets/img/badges/Social-Awareness/Badge-How-Actions-Affect-Others-Level-2.svg';
import ActionsAffect3 from 'assets/img/badges/Social-Awareness/Badge-How-Actions-Affect-Others-Level-3.svg';
import ActionsAffect4 from 'assets/img/badges/Social-Awareness/Badge-How-Actions-Affect-Others-Level-4.svg';
import ActionsAffect5 from 'assets/img/badges/Social-Awareness/Badge-How-Actions-Affect-Others-Level-5.svg';
import ActionsAffectMaster from 'assets/img/badges/Social-Awareness/Badge-How-Actions-Affect-Others-Master.svg';
// Self Management
import GoalSetting1 from 'assets/img/badges/Self-Management/Badge-Goal-Setting-Level-1.svg';
import GoalSetting2 from 'assets/img/badges/Self-Management/Badge-Goal-Setting-Level-2.svg';
import GoalSetting3 from 'assets/img/badges/Self-Management/Badge-Goal-Setting-Level-3.svg';
import GoalSetting4 from 'assets/img/badges/Self-Management/Badge-Goal-Setting-Level-4.svg';
import GoalSetting5 from 'assets/img/badges/Self-Management/Badge-Goal-Setting-Level-5.svg';
import GoalSettingMaster from 'assets/img/badges/Self-Management/Badge-Goal-Setting-Master.svg';
import ImpulseControl1 from 'assets/img/badges/Self-Management/Badge-Impulse-Control-Level-1.svg';
import ImpulseControl2 from 'assets/img/badges/Self-Management/Badge-Impulse-Control-Level-2.svg';
import ImpulseControl3 from 'assets/img/badges/Self-Management/Badge-Impulse-Control-Level-3.svg';
import ImpulseControl4 from 'assets/img/badges/Self-Management/Badge-Impulse-Control-Level-4.svg';
import ImpulseControl5 from 'assets/img/badges/Self-Management/Badge-Impulse-Control-Level-5.svg';
import ImpulseControlMaster from 'assets/img/badges/Self-Management/Badge-Impulse-Control-Master.svg';
import StressManagement1 from 'assets/img/badges/Self-Management/Badge-Stress-Management-Level-1.svg';
import StressManagement2 from 'assets/img/badges/Self-Management/Badge-Stress-Management-Level-2.svg';
import StressManagement3 from 'assets/img/badges/Self-Management/Badge-Stress-Management-Level-3.svg';
import StressManagement4 from 'assets/img/badges/Self-Management/Badge-Stress-Management-Level-4.svg';
import StressManagement5 from 'assets/img/badges/Self-Management/Badge-Stress-Management-Level-5.svg';
import StressManagementMaster from 'assets/img/badges/Self-Management/Badge-Stress-Management-Master.svg';
// Decision Making
import AnalyzingSituations1 from 'assets/img/badges/Responsible-Decision-Making/Badge-Analyzing-Situations-Level-1.svg';
import AnalyzingSituations2 from 'assets/img/badges/Responsible-Decision-Making/Badge-Analyzing-Situations-Level-2.svg';
import AnalyzingSituations3 from 'assets/img/badges/Responsible-Decision-Making/Badge-Analyzing-Situations-Level-3.svg';
import AnalyzingSituations4 from 'assets/img/badges/Responsible-Decision-Making/Badge-Analyzing-Situations-Level-4.svg';
import AnalyzingSituations5 from 'assets/img/badges/Responsible-Decision-Making/Badge-Analyzing-Situations-Level-5.svg';
import AnalyzingSituationsMaster from 'assets/img/badges/Responsible-Decision-Making/Badge-Analyzing-Situations-Master.svg';
import DecisionsGoals1 from 'assets/img/badges/Responsible-Decision-Making/Badge-How-Decisions-Affect-Goals-Level-1.svg';
import DecisionsGoals2 from 'assets/img/badges/Responsible-Decision-Making/Badge-How-Decisions-Affect-Goals-Level-2.svg';
import DecisionsGoals3 from 'assets/img/badges/Responsible-Decision-Making/Badge-How-Decisions-Affect-Goals-Level-3.svg';
import DecisionsGoals4 from 'assets/img/badges/Responsible-Decision-Making/Badge-How-Decisions-Affect-Goals-Level-4.svg';
import DecisionsGoals5 from 'assets/img/badges/Responsible-Decision-Making/Badge-How-Decisions-Affect-Goals-Level-5.svg';
import DecisionsGoalsMaster from 'assets/img/badges/Responsible-Decision-Making/Badge-How-Decisions-Affect-Goals-Master.svg';
import ProblemSolving1 from 'assets/img/badges/Responsible-Decision-Making/Badge-System-of-Problem-Solving-Level-1.svg';
import ProblemSolving2 from 'assets/img/badges/Responsible-Decision-Making/Badge-System-of-Problem-Solving-Level-2.svg';
import ProblemSolving3 from 'assets/img/badges/Responsible-Decision-Making/Badge-System-of-Problem-Solving-Level-3.svg';
import ProblemSolving4 from 'assets/img/badges/Responsible-Decision-Making/Badge-System-of-Problem-Solving-Level-4.svg';
import ProblemSolving5 from 'assets/img/badges/Responsible-Decision-Making/Badge-System-of-Problem-Solving-Level-5.svg';
import ProblemSolvingMaster from 'assets/img/badges/Responsible-Decision-Making/Badge-System-of-Problem-Solving-Master.svg';

const competencyData = {
  "self-management": {
    title: "Self Management",
    description: "Self Management is the ability to control one self as we experience our environment. According to the Collaborative for Academic, Social, and Emotional Learning (CASEL), it involves the abilities to manage stress, control impulses, self-motivate, create and work toward goals.",
    targetedSkills: [
      { title: "Impulse control", link: "impulse-control" },
      { title: "Stress management", link: "stress-management" },
      // { title: "Self-discipline", link: "self-discipline" },
      // { title: "Self-motivation", link: "self-motivation" },
      { title: "Goal-setting", link: "goal-setting" }
      // { title: "Organizational skills", link: "organizational-skills" }
    ],
    icon: SelfManagement
  },
  "self-awareness": {
    title: "Self Awareness",
    description: 'Self Awareness is the ability and experience of a clearer understanding of your own personality, strengths, weaknesses, motives, thoughts, beliefs, and emotions. According to the Collaborative for Academic, Social, and Emotional Learning (CASEL), it includes aspects like "growth mindset."',
    targetedSkills: [
      { title: "Identifying emotions", link: "identifying-emotions" },
      // { title: "Accurate self-perception", link: "accurate-self-perception" },
      { title: "Recognizing strengths", link: "recognizing-strengths" },
      { title: "Self-confidence", link: "self-confidence" }
      // { title: "Self-efficacy", link: "self-efficacy" }
    ],
    icon: SelfAwareness
  },
  "social-awareness": {
    title: "Social Awareness",
    description: 'Social Awareness is the ability "take" the perspective of others. We are careful to draw a line between empathy and sympathy, as it relates to context. The Collaborative for Academic, Social, and Emotional Learning (CASEL) adds the ability to understand diversity, social and ethical norms and recognize support resources.',
    targetedSkills: [
      // { title: "Perspective-taking", link: "perspective-taking" },
      { title: "Emotional Empathy", link: "empathy" },
      { title: "Appreciating diversity", link: "appreciating-diversity" },
      { title: "Respect for others", link: "respect-for-others" }
    ],
    icon: SocialAwareness
  },
  "relationship-skills": {
    title: "Relationship Skills",
    description: "Relationship Skills encompass abilities to form and maintain constructive relationships with peers from diverse backgrounds and functioning in various roles. The Collaborative for Academic, Social, and Emotional Learning (CASEL) considers aspects including communication, cooperation, understanding and responding to peer pressures and resolving conflict effectively.",
    targetedSkills: [
      { title: "Positive Communication", link: "communication" },
      { title: "Social Engagement", link: "social-engagement" },
      // { title: "Relationship-building", link: "relationship-building" },
      { title: "Teamwork", link: "teamwork" }
    ],
    icon: RelationshipSkills
  },
  "responsible-decision-making": {
    title: "Responsible Decision Making",
    description: "Responsible decision-making is about making effective decisions by evaluating, analyzing and reflecting on multiple approaches and options. The Collaborative for Academic, Social, and Emotional Learning (CASEL) considers the process in the context of consequences and impact of actions.",
    targetedSkills: [
      // { title: "Identifying Problems", link: "identifying-problems" },
      { title: "Analyzing Situations", link: "analyzing-situations" },
      { title: "System of Problem-solving", link: "solving-problems" },
      // { title: "Evaluating", link: "evaluating" },
      { title: "Reflecting on Actions", link: "reflecting" }
      // { title: "Ethical Responsibility", link: "ethical-responsibility" }
    ],
    icon: ResponsibleDecisionMaking
  }
};

const targetedSkills = {
  "impulse-control": {
    title: "Impulse Control",
    description: "Ability to resist an urge, temptation, impulse or to avoid acting prematurely or without foresight.",
    howUnytedDoesIt: "Our unique collaborative activities provide opportunities to practice the skill both in a developmentally appropriate way and with quicker feedback.",
    realLifeApplication: "The increasing use of smart phones, social media and other modern technologies increasingly test current and future generations' abilities to delay gratification. Instant gratification trickles into everything from a simple conversation to leadership (at all levels!).",
    category: "self-management",
    icon: ImpulseControl
  },
  "stress-management": {
    title: "Stress Management",
    description: "Actions taken to adjust to external and internal demands in the face of limited resources or anxiety",
    howUnytedDoesIt: <span>A repeated theme throughout Unyted collaborative activities is healthy conflict - personally and as it relates to others. In this case, the <Link to="/the-team-method">TEAM Method&trade;</Link> induces learners to explain their understanding, in a group, often against a timer. Feedback on how to manage these situations is made immediately available.</span>,
    realLifeApplication: "If we know anything about modern times is that people of all ages are increasingly taxed with anxiety. Why? Information is everywhere! The rate of change is faster than ever before. To be best prepared, we all need to build this skill and apply it in real world scenarios.",
    category: "self-management",
    icon: StressManagement
  },
  // "self-discipline": {
  //   title: "Self Discipline",
  //   description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  //   howUnytedDoesIt: ,
  //   realLifeApplication: ,
  //   category: "self-management"
  // },
  // "self-motivation": {
  //   title: "Self Motivation",
  //   description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  //   howUnytedDoesIt: ,
  //   realLifeApplication: ,
  //   category: "self-management"
  // },
  "goal-setting": {
    title: "Goal Setting",
    description: "Ability to set and manage both short and long-term goals, and efficiently manage time in efforts to attain success.",
    howUnytedDoesIt: <span>Unyted places the learner in control for many aspects of the learning process. The <Link to="/the-team-method">TEAM Method&trade;</Link> places learners on a team where they must cooperate. To blend both individual and collective goals, learners naturally develop the skill to reach a common goal. Learners also select their own tracks and use autonomy to accelerate their learning.</span>,
    realLifeApplication: "Setting goals sparks new habits and behaviors. Without goals, how can we measure progress? Setting both long and short term goals and developing the skills to navigate both individual and collective barriers prepares every learner for the real world.",
    category: "self-management",
    icon: GoalSetting
  },
  // "organizational-skills": {
  //   title: "Organizational Skills",
  //   description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  //   howUnytedDoesIt: ,
  //   realLifeApplication: ,
  //   category: "self-management"
  // },
  "identifying-emotions": {
    title: "Identifying Emotions",
    description: "Ability to identify emotion in one's physical states, feelings, and thoughts.",
    howUnytedDoesIt: "With opportunities for healthy intra and interpersonal conflict as learners work together toward consensus, learners have consistent opportunities to label feelings like frustration, anxiety, excitement and more. Especially with the help of a teacher, facilitator or coach.",
    realLifeApplication: "The ability to identify your own emotions is a critical first step in maintaining progress toward goals and interacting with others. Our emotions are cues or communications to others when working toward a common goal.",
    category: "self-awareness",
    icon: IdentifyingEmotions
  },
  // "accurate-self-perception": {
  //   title: "Accurate Self Perception",
  //   description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  //   howUnytedDoesIt: ,
  //   realLifeApplication: ,
  //   category: "self-awareness"
  // },
  "recognizing-strengths": {
    title: "Recognizing Strengths and Limitations",
    description: "Ability to recognize personal areas of strengths and limitations",
    howUnytedDoesIt: "The platform allows teachers and coaches to give data-driven academic feedback. Additionally, the platform's patent-pending technology is able to give personalized SEL guidance for each learner.",
    realLifeApplication: "Understanding your strengths and limitations keeps you striving toward your unique potential. For example, if you are looking at jobs, you could focus on opportunities that best match your strengths. In life, interacting with others is often more successful when we understand our own personality strengths and tendencies.",
    category: "self-awareness",
    icon: RecognizingStrengths
  },
  "self-confidence": {
    title: "Self Confidence",
    description: "Tendency for you to express positive feelings about your own skills and self.",
    howUnytedDoesIt: "The name of the game is continuous growth. Unyted believes each learner has unique potential and provides continuous guidance to help build learners' academic and SEL (personal) skills from whatever level. This growth process helps learners build confidence.",
    realLifeApplication: " Self-confidence has a direct relationship with reaching your unique potential. From motivation to more resilience, self-confidence is needed more than ever because of how how current times (and certain an unpredictable future) require us to adapt and learn as we work toward success in anything.",
    category: "self-awareness",
    icon: SelfConfidence
  },
  "self-efficacy": {
    title: "Self efficacy",
    description: "Ability to identify emotion in one's physical states, feelings, and thoughts.",
    howUnytedDoesIt: "With opportunities for healthy intra and interpersonal conflict as learners work together toward consensus, learners have consistent opportunities to label feelings like frustration, anxiety, excitement and more. Especially with the help of a teacher, facilitator or coach.",
    realLifeApplication: "The ability to identify your own emotions is a critical first step in maintaining progress toward goals and interacting with others. Our emotions are cues or communications to others when working toward a common goal.",
    category: "self-awareness"
  },
  "perspective-taking": {
    title: "Perspective Taking",
    description: "Ability to identify emotion in one's physical states, feelings, and thoughts.",
    howUnytedDoesIt: "With opportunities for healthy intra and interpersonal conflict as learners work together toward consensus, learners have consistent opportunities to label feelings like frustration, anxiety, excitement and more. Especially with the help of a teacher, facilitator or coach.",
    realLifeApplication: "The ability to identify your own emotions is a critical first step in maintaining progress toward goals and interacting with others. Our emotions are cues or communications to others when working toward a common goal.",
    category: "social-awareness"
  },
  "empathy": {
    title: "Emotional Empathy",
    description: 'The ability to sense and understand another’s feelings as if they were your own, though famously stated to never lose the feeling "as if" in the process',
    howUnytedDoesIt: 'Because Unyted focuses on collaborative learning activities in order to learn faster and better, learners repeatedly put what some call "mirror neurons" in action. This allows learners to feel and understand a teammates as they work through their interpersonal goals.',
    realLifeApplication: `While empathy was once thought to be innate or inborn, research now shows its capacity is innate, but our environment allows us to develop the skill. There's an increasing need to work together on complex tasks - both in work and life. Therefore, empathy isn't merely a "soft" skill, but rather a critical component of success in the real world.`,
    category: "social-awareness",
    icon: Empathy
  },
  "appreciating-diversity": {
    title: "Appreciating Diversity",
    description: 'More than diversity of background or culture, this skill focuses on diversity of perspective, opinion, ability and overall contribution. Its theme is "everyone brings something to the table."',
    howUnytedDoesIt: <span>The <Link to="/the-team-method">TEAM Method&trade;</Link> and its collaborative learning activities strongly encourage the idea of "the whole is greater than the sum of its parts." When learners are placed into scenarios where they need each other in order to move forward, this specific skill is significantly useful in leveraging differences for a team's common goal.</span>,
    realLifeApplication: "From Unyted's perspective, diversity can be a barrier or a springboard. In a world where information moves quickly and people of different backgrounds, opinions and abilities are able to work together or hold each other back from progress, this skill becomes a superpower for people who can leverage different perspectives to form a better result.",
    category: "social-awareness",
    icon: AppreciatingDiversity
  },
  "respect-for-others": {
    title: "Respect For Others' Opinions",
    description: "The ability to listen to, consider, and work with perspectives and opinions different than your own.",
    howUnytedDoesIt: <span>The <Link to="/the-team-method">TEAM Method&trade;</Link> (patent-pending technology) used in all collaborative learning activities requires learners to form a consensus in the process of moving forward. This is completely unique technology that maximizes the development of this skill because, while learning anything, learners are naturally in the position to consider the perspectives of others.</span>,
    realLifeApplication: "Opinions, perspectives and overall strong views have never been more widely shared than in current times. The advent and growth of social media technology and work communication tools to connect people all over the world means people from diverse backgrounds and opinions often interact to work on or through common goals. The key is to develop the skill to maintain focus on a common goal despite the reality of a difference of opinion.",
    category: "social-awareness",
    icon: RespectForOthers
  },
  "communication": {
    title: "Positive Communication",
    description: "Whether it's one-on-one, in groups, via electronic means or in-person, learners can speak, write, listen actively and appropriately and understand there is also non-verbal communication to consider.",
    howUnytedDoesIt: <span>No team can move forward without effective communication. The <Link to="/the-team-method">TEAM Method&trade;</Link> quite literally puts communication on main display. The basis of moving forward are the discussions between learners in a group, and that happens at all of the levels: one-to-one, group, electronically and in-person. The cutting edge technology makes all of this communication visible for teachers and coaches to continuously refine the skill.</span>,
    realLifeApplication: "Communication makes the current and future world go round. Whether you want to succeed in school, a career or life, you need to know how to capture opportunities and overcome obstacles. And, communication is the catalyst for progress toward any of those goals. Being placed into situations that more closely mirror the fast pace real-world is a critical component of developing this multi-faceted skill.",
    category: "relationship-skills",
    icon: Communication
  },
  "social-engagement": {
    title: "Social Engagement",
    description: "How someone engages and interacts with a group or community and its members. Not to be confused with extraversion, Social Engagement is more closely related to the degree of willingness to participate in a group for both individual and collective benefit.",
    howUnytedDoesIt: `Unyted's mission revolves around matching learning to the real world, and therefore simulates real world scenarios that involve participating in groups to reach a common goal. Whether a person is introverted or extraverted merely speaks to personality differences, tendencies or preferences. Unyted steers clear of "changing" learners to be more toward the extroversion side of the spectrum and instead focuses on building the skill to be able to engage and participate in a group for self-benefit and contribution to a shared benefit.`,
    realLifeApplication: 'There are few things we can accomplish "alone" in such a fast-paced, connected world. While some may set out to do as much as possible in isolation, results are still often greatly affected by the ability to either communicate or work with others to progress toward your goals.',
    category: "relationship-skills",
    icon: SocialEngagement
  },
  "relationship-building": {
    title: "Relationship-building",
    description: "Ability to identify emotion in one's physical states, feelings, and thoughts.",
    howUnytedDoesIt: "With opportunities for healthy intra and interpersonal conflict as learners work together toward consensus, learners have consistent opportunities to label feelings like frustration, anxiety, excitement and more. Especially with the help of a teacher, facilitator or coach.",
    realLifeApplication: "The ability to identify your own emotions is a critical first step in maintaining progress toward goals and interacting with others. Our emotions are cues or communications to others when working toward a common goal.",
    category: "relationship-skills"
  },
  "teamwork": {
    title: "Teamwork",
    description: 'The ability to work well with others toward a common goal by contributing and supporting through your own strengths and adjusting your role to cooperatively achieve tasks and goals efficiently and effectively. Distinguished from social engagement - a skill focused more on "willingness."',
    howUnytedDoesIt: <span>At the very heart of Unyted (hey, the technology is called Unyted!) is the ability to cooperate and leverage a group to accomplish goals that benefit yourself and others in a team. The <Link to="/the-team-method">TEAM Method&trade;</Link> puts this skill in constant practice by learning in activities as a connected group!</span>,
    realLifeApplication: 'The famous saying is "teamwork makes the dream work," right? To thrive in a highly competitive world of work and life, our ability to effectively cooperate and play different roles allows us to adapt to whatever is needed and keep pace with the competition (in anything). Whether you play a role as a leader or as another part of a team, the team unit, if effective, can do more than any one member. And, therefore, becomes extremely important as competition in work and life increases.',
    category: "relationship-skills",
    icon: Teamwork
  },
  "identifying-problems": {
    title: "Identifying Problems",
    description: "Ability to identify emotion in one's physical states, feelings, and thoughts.",
    howUnytedDoesIt: "With opportunities for healthy intra and interpersonal conflict as learners work together toward consensus, learners have consistent opportunities to label feelings like frustration, anxiety, excitement and more. Especially with the help of a teacher, facilitator or coach.",
    realLifeApplication: "The ability to identify your own emotions is a critical first step in maintaining progress toward goals and interacting with others. Our emotions are cues or communications to others when working toward a common goal.",
    category: "responsible-decision-making"
  },
  "analyzing-situations": {
    title: "Analyzing Situations",
    description: "The ability to identify a topic, problem or issue, gather information, develop possible solution, test solutions or ideas and review.",
    howUnytedDoesIt: <span>The <Link to="/the-team-method">TEAM Method&trade;</Link> consistently presents opportunities for individual learners and teams to address problems from multiple angles and show how they moved forward. The visibility of the re-imagined discussion board allows teachers and coaches to develop analytical skills in the process of learning any academic or non-academic concept faster and deeper.</span>,
    realLifeApplication: `In a world of ever-increasing automation and technology, your ability to analyze and work "between the machines" is more than just an advantage; it's soon to be a necessity. Analytical skills are therefore core skills needed to find solutions to common problems in work and life.`,
    category: "responsible-decision-making",
    icon: AnalyzingSituations
  },
  "solving-problems": {
    title: "System of Problem-solving",
    description: "The ability to identify problems or issues, seek alternative solutions or consider multiple sides, make decisions and evaluate results, all within an interdependent, dynamic system. It's distinguished from linear, step-by-step processes.",
    howUnytedDoesIt: <span>The <Link to="/the-team-method">TEAM Method&trade;</Link> places learners in a position to solve problems collaboratively and the technology captures data on how learners go about their process. This data becomes direct feedback and is then used by learners, teachers and coaches to continuously improve each individual learner's problem solving skills.</span>,
    realLifeApplication: 'The World Economic Forum identified complex problem-solving as the number one skill people will need to thrive in the workforce of the future. We agree with this skill as a critical priority because of the increases in automation and uses of technology. Problem solving skills will, once again, allow people to work "between the machines."',
    category: "responsible-decision-making",
    icon: SystemOfProblemSolving
  },
  "evaluating": {
    title: "Evaluating",
    description: "Ability to identify emotion in one's physical states, feelings, and thoughts.",
    howUnytedDoesIt: "With opportunities for healthy intra and interpersonal conflict as learners work together toward consensus, learners have consistent opportunities to label feelings like frustration, anxiety, excitement and more. Especially with the help of a teacher, facilitator or coach.",
    realLifeApplication: "The ability to identify your own emotions is a critical first step in maintaining progress toward goals and interacting with others. Our emotions are cues or communications to others when working toward a common goal.",
    category: "responsible-decision-making"
  },
  "reflecting": {
    title: "Reflecting on Actions",
    description: `Reflection is a “meaning-making process” that helps you use what you've learned to inform future goals and consider the real-life consequences of our actions and thoughts.`,
    howUnytedDoesIt: <span>Baked directly into the <Link to="/the-team-method">TEAM Method&trade;</Link> is the process of learners continuously reflecting on what they've done or thought within activities. Unique features within the platform allow learners to receive real-time (live!) feedback and in a format to easily review or make meaning out of their interactions with an academic topic or their peers. The key is Unyted's ability to provide visibility to learners, teachers and coaches.</span>,
    realLifeApplication: `The research shows learning and reflection are closely tied together. Put roughly, your learning happens from reflecting on actions or experiences. Have you ever read or heard the quote "the illiterate of the 21st century aren't those unable to read or write, but those unable to learn, unlearn and re-learn?" It's our ability to learn quickly that will help us adapt to unpredictable changes and extreme uncertainty. Without a developed skill to reflect, we cannot learn effectively or quickly enough. Will you be ready?`,
    category: "responsible-decision-making",
    icon: ReflectingOnActions
  },
  "ethical-responsibility": {
    title: "Ethical Responsibility",
    description: "Ability to identify emotion in one's physical states, feelings, and thoughts.",
    howUnytedDoesIt: "With opportunities for healthy intra and interpersonal conflict as learners work together toward consensus, learners have consistent opportunities to label feelings like frustration, anxiety, excitement and more. Especially with the help of a teacher, facilitator or coach.",
    realLifeApplication: "The ability to identify your own emotions is a critical first step in maintaining progress toward goals and interacting with others. Our emotions are cues or communications to others when working toward a common goal.",
    category: "responsible-decision-making"
  }
};

const generateLevels = (skill, levelData) => {
  const underscored = skill.split("-").join("_");

  return _.map(_.range(1, 7), level => {
    const levelName = level === 6 ? "Master" : `Level ${level}`;

    return ({
      dbName: `${underscored}_level_${level}`,
      ...levelData[level - 1],
      teacherDescriptor: `${levelName}: ${levelData[level - 1] && levelData[level - 1].teacherDescriptor}`,
      descriptor: `${levelName}: ${levelData[level - 1] && levelData[level - 1].descriptor}`,
      category: skill
    });
  });
};

const getTsLevelName = skill => {
  const [skillName, level] = skill.split("level");

  const levelNumber = Number(_.replace(level, "_", "")) - 1;
  const dashedSkillName = skillName.split("_").join("-");

  const skillObject = targetedSkillsWithLevels[dashedSkillName.substring(0, dashedSkillName.length - 1)];

  return skillObject ?
    skillObject.levels[levelNumber] :
    "Unknown Skill";
};

const targetedSkillsWithLevels = {
  "impulse-control": {
    title: "Impulse Control",
    levels: [...generateLevels("impulse-control", [
      {
        teacherDescriptor: "Understands that thoughts are connected to behaviors (K-2)",
        descriptor: "Understands that thoughts are connected to behaviors",
        humanName: "Impulse Control",
        icon: ImpulseControl1
      },
      {
        teacherDescriptor: "Can describe how emotions relate to behaviors (3-5)",
        descriptor: "Can describe how emotions relate to behaviors",
        humanName: "Impulse Control",
        icon: ImpulseControl2
      },
      {
        teacherDescriptor: "Demonstrates skill to respond effectively to pressure situations (6-8)",
        descriptor: "Demonstrates skill to respond effectively to pressure situations",
        humanName: "Impulse Control",
        icon: ImpulseControl3
      },
      {
        teacherDescriptor: "Reflects on possible consequences before expressing an emotion or behavior (9-10)",
        descriptor: "Reflects on possible consequences before expressing an emotion or behavior",
        humanName: "Impulse Control",
        icon: ImpulseControl4
      },
      {
        teacherDescriptor: " Identifies and practices strategies for overcoming feelings of rejection, isolation, and other forms of stress causing loss of impulse control (11-12)",
        descriptor: " Identifies and practices strategies for overcoming feelings of rejection, isolation, and other forms of stress causing loss of impulse control",
        humanName: "Impulse Control",
        icon: ImpulseControl5
      },
      {
        teacherDescriptor: "Evaluates the environment and determines how emotions can lead to loss of impulse control and affect others (Adult)",
        descriptor: "Evaluates the environment and determines how emotions can lead to loss of impulse control and affect others",
        humanName: "Impulse Control",
        icon: ImpulseControlMaster
      }
    ])],
    category: "self-management",
    icon: ImpulseControl
  },
  "stress-management": {
    title: "Stress Management",
    levels: [...generateLevels("stress-management", [
      {
        teacherDescriptor: "Understands the concept of stress and its effects (K-2)",
        descriptor: "Understands the concept of stress and its effects",
        humanName: "Stress Management",
        icon: StressManagement1
      },
      {
        teacherDescriptor: "Identifies sources of common stress (3-5)",
        descriptor: "Identifies sources of common stress",
        humanName: "Stress Management",
        icon: StressManagement2
      },
      {
        teacherDescriptor: "Uses self-monitoring to manage stress and regulate emotions (6-8)",
        descriptor: "Uses self-monitoring to manage stress and regulate emotions",
        humanName: "Stress Management",
        icon: StressManagement3
      },
      {
        teacherDescriptor: "Maintains confidence during stressful situations (9-10)",
        descriptor: "Maintains confidence during stressful situations",
        humanName: "Stress Management",
        icon: StressManagement4
      },
      {
        teacherDescriptor: "Demonstrates the ability to reframe difficult situations into opportunities (11-12)",
        descriptor: "Demonstrates the ability to reframe difficult situations into opportunities",
        humanName: "Stress Management",
        icon: StressManagement5
      },
      {
        teacherDescriptor: "Evaluates the impact of techniques used to manage stress and emotions (Adult)",
        descriptor: "Evaluates the impact of techniques used to manage stress and emotions",
        humanName: "Stress Management",
        icon: StressManagementMaster
      }
    ])],
    description: "Actions taken to adjust to external and internal demands in the face of limited resources or anxiety",
    category: "self-management",
    icon: StressManagement
  },
  // "self-discipline": {
  //   title: "Self Discipline",
  //   levels: [...generateLevels("self-discipline", [
  //     "Doing something, Level 1",
  //     "Doing something, Level 3",
  //     "Doing something, Level 4",
  //     "Doing something, Level 5"
  //   ])],
  //   description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  //   category: "self-management"
  // },
  // "self-motivation": {
  //   title: "Self Motivation",
  //   levels: [...generateLevels("self-motivation", [
  //     "Doing something, Level 1",
  //     "Doing something, Level 3",
  //     "Doing something, Level 4",
  //     "Doing something, Level 5"
  //   ])],
  //   description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  //   category: "self-management"
  // },
  "goal-setting": {
    title: "Goal Setting",
    levels: [...generateLevels("goal-setting", [
      {
        teacherDescriptor: "Understands the concept of goals and why it matters (K-2)",
        descriptor: "Understands the concept of goals and why it matters",
        humanName: "Goal Setting",
        icon: GoalSetting1
      },
      {
        teacherDescriptor: "Identifies a short-term goal and steps needed to reach it (3-5)",
        descriptor: "Identifies a short-term goal and steps needed to reach it",
        humanName: "Goal Setting",
        icon: GoalSetting2
      },
      {
        teacherDescriptor: "Knows the difference between short-term and long-term goals (6-8)",
        descriptor: "Knows the difference between short-term and long-term goals",
        humanName: "Goal Setting",
        icon: GoalSetting3
      },
      {
        teacherDescriptor: "Designs action plans for achieving short and long-term goals and timelines to achieve them (9-10)",
        descriptor: "Designs action plans for achieving short and long-term goals and timelines to achieve them",
        humanName: "Goal Setting",
        icon: GoalSetting4
      },
      {
        teacherDescriptor: "Demonstrates understanding of how academic goals connect with life long success (11-12)",
        descriptor: "Demonstrates understanding of how academic goals connect with life long success",
        humanName: "Goal Setting",
        icon: GoalSetting5
      },
      {
        teacherDescriptor: "Evaluates goal achievement and identifies external sources to help improve subsequent attempts (Adult)",
        descriptor: "Evaluates goal achievement and identifies external sources to help improve subsequent attempts",
        humanName: "Goal Setting",
        icon: GoalSettingMaster
      }
    ])],
    description: "Ability to set and manage both short and long-term goals, and efficiently manage time in efforts to attain success.",
    category: "self-management",
    icon: GoalSetting
  },
  // "organizational-skills": {
  //   title: "Organizational Skills",
  //   levels: [...generateLevels("organizational-skills", [
  //     "Doing something, Level 1",
  //     "Doing something, Level 3",
  //     "Doing something, Level 4",
  //     "Doing something, Level 5"
  //   ])],
  //   description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  //   category: "self-management"
  // },
  "identifying-emotions": {
    title: "Identifying Emotions",
    levels: [...generateLevels("identifying-emotions", [
      {
        teacherDescriptor: "Recognizes and accurately names feelings (K-2)",
        descriptor: "Recognizes and accurately names feelings",
        humanName: "Identifying Emotions",
        icon: CommunicatesFeelings1
      },
      {
        teacherDescriptor: "Identifies and communicates feelings (3-5)",
        descriptor: "Identifies and communicates feelings",
        humanName: "Identifying Emotions",
        icon: CommunicatesFeelings2
      },
      {
        teacherDescriptor: "Recognizes intensity levels of emotions in different situations (6-8)",
        descriptor: "Recognizes intensity levels of emotions in different situations",
        humanName: "Identifying Emotions",
        icon: CommunicatesFeelings3
      },
      {
        teacherDescriptor: "Recognizes uncomfortable emotions as signs of situations that need attention (9-10)",
        descriptor: "Recognizes uncomfortable emotions as signs of situations that need attention",
        humanName: "Identifying Emotions",
        icon: CommunicatesFeelings4
      },
      {
        teacherDescriptor: "Identifies personal emotions as valid, regardless of how others expect them to feel (11-12)",
        descriptor: "Identifies personal emotions as valid, regardless of how others expect them to feel",
        humanName: "Identifying Emotions",
        icon: CommunicatesFeelings5
      },
      {
        teacherDescriptor: "Identifies, recognizes, and names complex emotions in the moment (Adult)",
        descriptor: "Identifies, recognizes, and names complex emotions in the moment",
        humanName: "Identifying Emotions",
        icon: CommunicatesFeelingsMaster
      }
    ])],
    description: "Ability to identify emotion in one's physical states, feelings, and thoughts.",
    category: "self-awareness",
    icon: IdentifyingEmotions
  },
  // "accurate-self-perception": {
  //   title: "Accurate Self Perception",
  //   levels: [...generateLevels("accurate-self-perception", [
  //     "Doing something, Level 1",
  //     "Doing something, Level 3",
  //     "Doing something, Level 4",
  //     "Doing something, Level 5"
  //   ])],
  //   description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  //   category: "self-awareness"
  // },
  "recognizing-strengths": {
    title: "Recognizing Strengths and Limitations",
    levels: [...generateLevels("recognizing-strengths", [
      {
        teacherDescriptor: "Identifies likes and dislikes (K-2)",
        descriptor: "Identifies likes and dislikes",
        humanName: "Identifying Emotions",
        icon: Strengthsandlimitations1
      },
      {
        teacherDescriptor: "Describes things one does well or knowledge they have (3-5)",
        descriptor: "Describes things one does well or knowledge they have",
        humanName: "Identifying Emotions",
        icon: Strengthsandlimitations2
      },
      {
        teacherDescriptor: "Identifies personal strengths and limitations generally (6-8)",
        descriptor: "Identifies personal strengths and limitations generally",
        humanName: "Identifying Emotions",
        icon: Strengthsandlimitations3
      },
      {
        teacherDescriptor: "Identifies personal strengths and limitations for specific situations and activities (9-10)",
        descriptor: "Identifies personal strengths and limitations for specific situations and activities",
        humanName: "Identifying Emotions",
        icon: Strengthsandlimitations4
      },
      {
        teacherDescriptor: "Identifies the skills and credentials required to enter a career and acts on curiosity (11-12)",
        descriptor: "Identifies the skills and credentials required to enter a career and acts on curiosity",
        humanName: "Identifying Emotions",
        icon: Strengthsandlimitations5
      },
      {
        teacherDescriptor: "Is realistic about goals in relation to strengths and limitations (Adult)",
        descriptor: "Is realistic about goals in relation to strengths and limitations",
        humanName: "Identifying Emotions",
        icon: StrengthsandlimitationsMaster
      }
    ])],
    description: "Ability to recognize personal areas of strengths and limitations",
    category: "self-awareness",
    icon: RecognizingStrengths
  },
  "recognizing-interests": {
    title: "Recognizes Personal Qualities and Interests",
    levels: [...generateLevels("recognizing-interests", [
      {
        teacherDescriptor: "Describes personal qualities and interests (K-2)",
        descriptor: "Describes personal qualities and interests",
        humanName: "Identifying Emotions",
        icon: PersonalQualities1
      },
      {
        teacherDescriptor: "Identifies an interest as it relates to personal experiences (3-5)",
        descriptor: "Identifies an interest as it relates to personal experiences",
        humanName: "Identifying Emotions",
        icon: PersonalQualities2
      },
      {
        teacherDescriptor: "Understands the relationship between interests and continued development and growth situations (6-8)",
        descriptor: "Understands the relationship between interests and continued development and growth situations",
        humanName: "Identifying Emotions",
        icon: PersonalQualities3
      },
      {
        teacherDescriptor: "Utilizes interest to gain experiences toward mastery of a skill or concept (9-10)",
        descriptor: "Utilizes interest to gain experiences toward mastery of a skill or concept",
        humanName: "Identifying Emotions",
        icon: PersonalQualities4
      },
      {
        teacherDescriptor: " Uses personal qualities and interests to make decisions regarding future goals (postsecondary, career, etc.) (11-12)",
        descriptor: " Uses personal qualities and interests to make decisions regarding future goals (postsecondary, career, etc.)",
        humanName: "Identifying Emotions",
        icon: PersonalQualities5
      },
      {
        teacherDescriptor: "Evaluates the impact of personal qualities and interests in decisions made (Adult)",
        descriptor: "Evaluates the impact of personal qualities and interests in decisions made",
        humanName: "Identifying Emotions",
        icon: PersonalQualitiesMaster
      }
    ])],
    description: "Ability to recognize personal areas of strengths and limitations",
    category: "self-awareness",
    icon: RecognizingStrengths
  },
  // "self-confidence": {
  //   title: "Self Confidence",
  //   levels: [...generateLevels("self-confidence", [
  //     "Doing something, Level 1",
  //     "Doing something, Level 3",
  //     "Doing something, Level 4",
  //     "Doing something, Level 5"
  //   ])],
  //   description: "Tendency for you to express positive feelings about your own skills and self.",
  //   category: "self-awareness",
  //   icon: SelfConfidence
  // },
  // "self-efficacy": {
  //   title: "Self efficacy",
  //   levels: [...generateLevels("self-efficacy", [
  //     "Doing something, Level 1",
  //     "Doing something, Level 3",
  //     "Doing something, Level 4",
  //     "Doing something, Level 5"
  //   ])],
  //   description: "Ability to identify emotion in one's physical states, feelings, and thoughts.",
  //   category: "self-awareness"
  // },
  // "perspective-taking": {
  //   title: "Perspective Taking",
  //   levels: [...generateLevels("perspective-taking", [
  //     "Doing something, Level 1",
  //     "Doing something, Level 3",
  //     "Doing something, Level 4",
  //     "Doing something, Level 5"
  //   ])],
  //   description: "Ability to identify emotion in one's physical states, feelings, and thoughts.",
  //   category: "social-awareness"
  // },
  "empathy": {
    title: "Emotional Empathy",
    levels: [...generateLevels("empathy", [
      {
        teacherDescriptor: "Recognizes emotions/feelings of others by listening (K-2)",
        descriptor: "Recognizes emotions/feelings of others by listening",
        humanName: "Emotional Empathy",
        icon: Empathy1
      },
      {
        teacherDescriptor: "Recognizes emotions/feelings of others by paying attention to facial expressions (3-5)",
        descriptor: "Recognizes emotions/feelings of others by paying attention to facial expressions",
        humanName: "Emotional Empathy",
        icon: Empathy2
      },
      {
        teacherDescriptor: "Describe emotions/feelings of others affect situations (6-8)",
        descriptor: "Describe emotions/feelings of others affect situations",
        humanName: "Emotional Empathy",
        icon: Empathy3
      },
      {
        teacherDescriptor: "Recognizes the emotions of others by visual or environmental cues (9-10)",
        descriptor: "Recognizes the emotions of others by visual or environmental cues",
        humanName: "Emotional Empathy",
        icon: Empathy4
      },
      {
        teacherDescriptor: "Anticipate the feelings of others in a variety of situations (11-12)",
        descriptor: "Anticipate the feelings of others in a variety of situations",
        humanName: "Emotional Empathy",
        icon: Empathy5
      },
      {
        teacherDescriptor: "Evaluates appropriateness of responses in different social situations and scenarios (Adult)",
        descriptor: "Evaluates appropriateness of responses in different social situations and scenarios",
        humanName: "Emotional Empathy",
        icon: EmpathyMaster
      }
    ])],
    description: 'The ability to sense and understand another’s feelings as if they were your own, though famously stated to never lose the feeling "as if" in the process',
    category: "social-awareness",
    icon: Empathy
  },
  "appreciating-diversity": {
    title: "Appreciating Diversity",
    levels: [...generateLevels("appreciating-diversity", [
      {
        teacherDescriptor: "Recognizes and accurately names feelings (K-2)",
        descriptor: "Recognizes and accurately names feelings",
        humanName: "Appreciating Diversity",
        icon: AppreciatingDiversity1
      },
      {
        teacherDescriptor: " Understand multiple viewpoints can work together (3-5)",
        descriptor: " Understand multiple viewpoints can work together",
        humanName: "Appreciating Diversity",
        icon: AppreciatingDiversity2
      },
      {
        teacherDescriptor: " Analyze how people from diverse backgrounds and viewpoints can learn from each other (6-8)",
        descriptor: " Analyze how people from diverse backgrounds and viewpoints can learn from each other",
        humanName: "Appreciating Diversity",
        icon: AppreciatingDiversity3
      },
      {
        teacherDescriptor: "Values and seeks different perspectives (9-10)",
        descriptor: "Values and seeks different perspectives",
        humanName: "Appreciating Diversity",
        icon: AppreciatingDiversity4
      },
      {
        teacherDescriptor: "Describe scenarios where “healthy conflict” can help (11-12)",
        descriptor: "Describe scenarios where “healthy conflict” can help",
        humanName: "Appreciating Diversity",
        icon: AppreciatingDiversity5
      },
      {
        teacherDescriptor: "Show strategies for using different perspectives to get a better result (Adult)",
        descriptor: "Show strategies for using different perspectives to get a better result",
        humanName: "Appreciating Diversity",
        icon: AppreciatingDiversityMaster
      }
    ])],
    description: 'More than diversity of background or culture, this skill focuses on diversity of perspective, opinion, ability and overall contribution. Its theme is "everyone brings something to the table."',
    category: "social-awareness",
    icon: AppreciatingDiversity
  },
  "actions-affect-others": {
    title: "Actions Affect Others",
    levels: [...generateLevels("appreciating-diversity", [
      {
        teacherDescriptor: "Recognizes the effect words have on others (K-2)",
        descriptor: "Recognizes the effect words have on others",
        humanName: "Actions Affect Others",
        icon: ActionsAffect1
      },
      {
        teacherDescriptor: "Recognizes the effect actions have on others (3-5)",
        descriptor: "Recognizes the effect actions have on others",
        humanName: "Actions Affect Others",
        icon: ActionsAffect2
      },
      {
        teacherDescriptor: "Recognizes non-verbal or environmental cues to identify how others feel (6-8)",
        descriptor: "Recognizes non-verbal or environmental cues to identify how others feel",
        humanName: "Actions Affect Others",
        icon: ActionsAffect3
      },
      {
        teacherDescriptor: "Analyzes ways a person can be affected by others’ actions (9-10)",
        descriptor: "Analyzes ways a person can be affected by others’ actions",
        humanName: "Actions Affect Others",
        icon: ActionsAffect4
      },
      {
        teacherDescriptor: "Predict the impact of own behavior on others’ emotions (11-12)",
        descriptor: "Predict the impact of own behavior on others’ emotions",
        humanName: "Actions Affect Others",
        icon: ActionsAffect5
      },
      {
        teacherDescriptor: "Uses consideration an intuition to be in tune with others’ needs (Adult)",
        descriptor: "Uses consideration an intuition to be in tune with others’ needs",
        humanName: "Actions Affect Others",
        icon: ActionsAffectMaster
      }
    ])],
    description: 'More than diversity of background or culture, this skill focuses on diversity of perspective, opinion, ability and overall contribution. Its theme is "everyone brings something to the table."',
    category: "social-awareness"
  },
  // "respect-for-others": {
  //   title: "Respect For Others' Opinions",
  //   levels: [...generateLevels("respect-for-others", [
  //     "Doing something, Level 1",
  //     "Doing something, Level 3",
  //     "Doing something, Level 4",
  //     "Doing something, Level 5"
  //   ])],
  //   description: "The ability to listen to, consider, and work with perspectives and opinions different than your own.",
  //   category: "social-awareness",
  //   icon: RespectForOthers
  // },
  "communication": {
    title: "Positive Communication",
    levels: [...generateLevels("communication", [
      {
        teacherDescriptor: "Verbal Etiquette as foundation for better communication (e.g. please, thank you, etc.) (K-2)",
        descriptor: "Verbal Etiquette as foundation for better communication (e.g. please, thank you, etc.)",
        humanName: "Positive Communication",
        icon: PositiveCommunication1
      },
      {
        teacherDescriptor: "Pays attention when others communicate and is able to take turns (3-5)",
        descriptor: "Pays attention when others communicate and is able to take turns",
        humanName: "Positive Communication",
        icon: PositiveCommunication2
      },
      {
        teacherDescriptor: "Uses active listening to have better communication (6-8)",
        descriptor: "Uses active listening to have better communication",
        humanName: "Positive Communication",
        icon: PositiveCommunication3
      },
      {
        teacherDescriptor: "Practices reflective listening during and after communication (9-10)",
        descriptor: "Practices reflective listening during and after communication",
        humanName: "Positive Communication",
        icon: PositiveCommunication4
      },
      {
        teacherDescriptor: "Uses assertive communication without negatively affecting others (11-12)",
        descriptor: "Uses assertive communication without negatively affecting others",
        humanName: "Positive Communication",
        icon: PositiveCommunication5
      },
      {
        teacherDescriptor: "Offers and accepts constructive criticism to help and be helped (Adult)",
        descriptor: "Offers and accepts constructive criticism to help and be helped",
        humanName: "Positive Communication",
        icon: PositiveCommunicationMaster
      }
    ])],
    description: "Whether it's one-on-one, in groups, via electronic means or in-person, learners can speak, write, listen actively and appropriately and understand there is also non-verbal communication to consider.",
    category: "relationship-skills",
    icon: Communication
  },
  "social-engagement": {
    title: "Social Engagement",
    levels: [...generateLevels("social-engagement", [
      {
        teacherDescriptor: "Describes approaches for making and keeping friends (K-2)",
        descriptor: "Describes approaches for making and keeping friends",
        humanName: "Social Engagement",
        icon: SocialEngagement1
      },
      {
        teacherDescriptor: "Engages with others to establish connections (3-5)",
        descriptor: "Engages with others to establish connections",
        humanName: "Social Engagement",
        icon: SocialEngagement2
      },
      {
        teacherDescriptor: "Demonstrates cooperative behaviors in a group, (6-8)",
        descriptor: "Demonstrates cooperative behaviors in a group,",
        humanName: "Social Engagement",
        icon: SocialEngagement3
      },
      {
        teacherDescriptor: "Demonstrates ability to play different roles in a group, (9-10)",
        descriptor: "Demonstrates ability to play different roles in a group,",
        humanName: "Social Engagement",
        icon: SocialEngagement4
      },
      {
        teacherDescriptor: "Demonstrates strategies for collaborating with peers to move group efforts forward, (11-12)",
        descriptor: "Demonstrates strategies for collaborating with peers to move group efforts forward,",
        humanName: "Social Engagement",
        icon: SocialEngagement5
      },
      {
        teacherDescriptor: "Demonstrates strategies for collaborating with peers to move group efforts forward in face of significant challenge (Adult)",
        descriptor: "Demonstrates strategies for collaborating with peers to move group efforts forward in face of significant challenge",
        humanName: "Social Engagement",
        icon: SocialEngagementMaster
      }
    ])],
    description: "How someone engages and interacts with a group or community and its members. Not to be confused with extraversion, Social Engagement is more closely related to the degree of willingness to participate in a group for both individual and collective benefit.",
    category: "relationship-skills",
    icon: SocialEngagement
  },
  "conflict-resolution": {
    title: "Conflict Resolution",
    levels: [...generateLevels("conflict-resolution", [
      {
        teacherDescriptor: "Identifies peer conflicts that need an adult to help resolve (K-2)",
        descriptor: "Identifies peer conflicts that need an adult to help resolve",
        humanName: "Conflict Resolution",
        icon: ConflictResolution1
      },
      {
        teacherDescriptor: "Shows an understanding that conflict is natural and can be healthy (3-5)",
        descriptor: "Shows an understanding that conflict is natural and can be healthy",
        humanName: "Conflict Resolution",
        icon: ConflictResolution2
      },
      {
        teacherDescriptor: "Engages in healthy conflict (6-8)",
        descriptor: "Engages in healthy conflict",
        humanName: "Conflict Resolution",
        icon: ConflictResolution3
      },
      {
        teacherDescriptor: "Applies conflict resolution skills to de-escalate, defuse and resolve conflicts (9-10)",
        descriptor: "Applies conflict resolution skills to de-escalate, defuse and resolve conflicts",
        humanName: "Conflict Resolution",
        icon: ConflictResolution4
      },
      {
        teacherDescriptor: "Uses listening and speaking skills that help prevent conflicts (11-12)",
        descriptor: "Uses listening and speaking skills that help prevent conflicts",
        humanName: "Conflict Resolution",
        icon: ConflictResolution5
      },
      {
        teacherDescriptor: "Develops and uses mediation skills (Adult)",
        descriptor: "Develops and uses mediation skills",
        humanName: "Conflict Resolution",
        icon: ConflictResolutionMaster
      }
    ])],
    description: "How someone engages and interacts with a group or community and its members. Not to be confused with extraversion, Social Engagement is more closely related to the degree of willingness to participate in a group for both individual and collective benefit.",
    category: "relationship-skills",
    icon: SocialEngagement
  },
  // "relationship-building": {
  //   title: "Relationship-building",
  //   levels: [...generateLevels("relationship-building", [
  //     "Doing something, Level 1",
  //     "Doing something, Level 3",
  //     "Doing something, Level 4",
  //     "Doing something, Level 5"
  //   ])],
  //   description: "Ability to identify emotion in one's physical states, feelings, and thoughts.",
  //   category: "relationship-skills"
  // },
  // "teamwork": {
  //   title: "Teamwork",
  //   levels: [...generateLevels("teamwork", [
  //     "Doing something, Level 1",
  //     "Doing something, Level 3",
  //     "Doing something, Level 4",
  //     "Doing something, Level 5"
  //   ])],
  //   description: 'The ability to work well with others toward a common goal by contributing and supporting through your own strengths and adjusting your role to cooperatively achieve tasks and goals efficiently and effectively. Distinguished from social engagement - a skill focused more on "willingness."',
  //   category: "relationship-skills",
  //   icon: Teamwork
  // },
  // "identifying-problems": {
  //   title: "Identifying Problems",
  //   levels: [...generateLevels("identifying-problems", [
  //     "Doing something, Level 1",
  //     "Doing something, Level 3",
  //     "Doing something, Level 4",
  //     "Doing something, Level 5"
  //   ])],
  //   description: "Ability to identify emotion in one's physical states, feelings, and thoughts.",
  //   category: "responsible-decision-making"
  // },
  "solving-problems": {
    title: "Understands System of Problem Solving",
    levels: [...generateLevels("solving-problems", [
      {
        teacherDescriptor: "Able to define a problem (K-2)",
        descriptor: "Able to define a problem",
        humanName: "Understanding systems of problem solving",
        icon: ProblemSolving1
      },
      {
        teacherDescriptor:  "Explains the problem-solving process (3-5)",
        descriptor:  "Explains the problem-solving process",
        humanName: "Understanding systems of problem solving",
        icon: ProblemSolving2
      },
      {
        teacherDescriptor: "Uses stop, think, act, review when faced with a problem (6-8)",
        descriptor: "Uses stop, think, act, review when faced with a problem",
        humanName: "Understanding systems of problem solving",
        icon: ProblemSolving3
      },
      {
        teacherDescriptor: "Identifies how problem-solving process is different depending on context or situation (9-10)",
        descriptor: "Identifies how problem-solving process is different depending on context or situation",
        humanName: "Understanding systems of problem solving",
        icon: ProblemSolving4
      },
      {
        teacherDescriptor: "Evaluate how reflection on process can help in future (11-12)",
        descriptor: "Evaluate how reflection on process can help in future",
        humanName: "Understanding systems of problem solving",
        icon: ProblemSolving5
      },
      {
        teacherDescriptor: "Anticipates problems in a variety of situations (Adult)",
        descriptor: "Anticipates problems in a variety of situations",
        humanName: "Understanding systems of problem solving",
        icon: ProblemSolvingMaster
      }
    ])],
    description: "The ability to identify problems or issues, seek alternative solutions or consider multiple sides, make decisions and evaluate results, all within an interdependent, dynamic system. It's distinguished from linear, step-by-step processes.",
    category: "responsible-decision-making",
    icon: SystemOfProblemSolving
  },
  "analyzing-situations": {
    title: "Considers both pros and cons",
    levels: [...generateLevels("analyzing-situations", [
      {
        teacherDescriptor: "Understands negative consequences (K-2)",
        descriptor: "Understands negative consequences",
        humanName: "Considers pros and cons",
        icon: AnalyzingSituations1
      },
      {
        teacherDescriptor:  "Understands how negative consequences can help make positive consequences more likely (3-5)",
        descriptor:  "Understands how negative consequences can help make positive consequences more likely",
        humanName: "Considers pros and cons",
        icon: AnalyzingSituations2
      },
      {
        teacherDescriptor:  "Explains negative and positive consequences in academic and social situations (6-8)",
        descriptor:  "Explains negative and positive consequences in academic and social situations",
        humanName: "Considers pros and cons",
        icon: AnalyzingSituations3
      },
      {
        teacherDescriptor:  "Shows consistent examples of analyzing negative and positive benefits (9-10)",
        descriptor:  "Shows consistent examples of analyzing negative and positive benefits",
        humanName: "Considers pros and cons",
        icon: AnalyzingSituations4
      },
      {
        teacherDescriptor:  "Evaluates pros and cons in a way that leads to more accurate or beneficial outcomes (11-12)",
        descriptor:  "Evaluates pros and cons in a way that leads to more accurate or beneficial outcomes",
        humanName: "Considers pros and cons",
        icon: AnalyzingSituations5
      },
      {
        teacherDescriptor:  "Can anticipate scenarios by projecting probable pros and cons (Adult)",
        descriptor:  "Can anticipate scenarios by projecting probable pros and cons",
        humanName: "Considers pros and cons",
        icon: AnalyzingSituationsMaster
      }
    ])],
    description: "The ability to identify a topic, problem or issue, gather information, develop possible solution, test solutions or ideas and review.",
    category: "responsible-decision-making",
    icon: AnalyzingSituations
  },
  "decision-goals": {
    title: "Understands how decisions affect goals",
    levels: [...generateLevels("decision-goals", [
      {
        teacherDescriptor: "Recognizes that one has choices (K-2)",
        descriptor: "Recognizes that one has choices",
        humanName: "Considers pros and cons",
        icon: DecisionsGoals1
      },
      {
        teacherDescriptor: "Understands that choices have consequences (3-5)",
        descriptor: "Understands that choices have consequences",
        humanName: "Considers pros and cons",
        icon: DecisionsGoals2
      },
      {
        teacherDescriptor: "Identifies social norms and peer situations that affect choices (6-8)",
        descriptor: "Identifies social norms and peer situations that affect choices",
        humanName: "Considers pros and cons",
        icon: DecisionsGoals3
      },
      {
        teacherDescriptor: "Identifies external influences (like media) that impact choices (9-10)",
        descriptor: "Identifies external influences (like media) that impact choices",
        humanName: "Considers pros and cons",
        icon: DecisionsGoals4
      },
      {
        teacherDescriptor: "Reflect on lessons learned (11-12)",
        descriptor: "Reflect on lessons learned",
        humanName: "Considers pros and cons",
        icon: DecisionsGoals5
      },
      {
        teacherDescriptor: "Evaluate how to apply lessons learned to future situations (Adult)",
        descriptor: "Evaluate how to apply lessons learned to future situations",
        humanName: "Considers pros and cons",
        icon: DecisionsGoalsMaster
      }
    ])],
    description: "The ability to connect how decisions affect goals",
    category: "responsible-decision-making"
  }
  // "evaluating": {
  //   title: "Evaluating",
  //   levels: [...generateLevels("evaluating", [
  //     "Doing something, Level 1",
  //     "Doing something, Level 3",
  //     "Doing something, Level 4",
  //     "Doing something, Level 5"
  //   ])],
  //   description: "Ability to identify emotion in one's physical states, feelings, and thoughts.",
  //   category: "responsible-decision-making"
  // },
  // "reflecting": {
  //   title: "Reflecting on Actions",
  //   levels: [...generateLevels("reflecting", [
  //     "Doing something, Level 1",
  //     "Doing something, Level 3",
  //     "Doing something, Level 4",
  //     "Doing something, Level 5"
  //   ])],
  //   description: `Reflection is a “meaning-making process” that helps you use what you've learned to inform future goals and consider the real-life consequences of our actions and thoughts.`,
  //   category: "responsible-decision-making",
  //   icon: ReflectingOnActions
  // },
  // "ethical-responsibility": {
  //   title: "Ethical Responsibility",
  //   levels: [...generateLevels("ethical-responsibility", [
  //     "Doing something, Level 1",
  //     "Doing something, Level 3",
  //     "Doing something, Level 4",
  //     "Doing something, Level 5"
  //   ])],
  //   description: "Ability to identify emotion in one's physical states, feelings, and thoughts.",
  //   category: "responsible-decision-making"
  // }
};

export {
  targetedSkills,
  targetedSkillsWithLevels,
  getTsLevelName
};

export default competencyData;
